export const startDateOne = '1 Start Date'
export const startDateTwo = '2 Start Date'
export const startDateThree = '3 Start Date'
